<div style="display: flex; flex-direction: column; gap: 5px">
    <app-saved-dashboard-view-loader
        [options]="options"
    ></app-saved-dashboard-view-loader>
    <div style="display: flex; gap: 5px">
        <button
            nz-button
            color="primary"
            (click)="onSaveView()"
            [disabled]="!canSaveView"
            nz-tooltip
            [nzTooltipTitle]="canSaveViewReason"
            nzSize="small"
            style="flex-grow: 1"
        >
            Save view
        </button>
        <button
            nz-button
            color="primary"
            (click)="onSaveViewAs()"
            nzSize="small"
            style="flex-grow: 1"
        >
            Save view as
        </button>
        <button
            nz-button
            color="primary"
            (click)="onQuickShareView()"
            nzSize="small"
            style="flex-grow: 1"
        >
            Quick share view
        </button>
    </div>
</div>

<nz-modal
    [(nzVisible)]="isModalVisible"
    nzTitle="Save filters {{ dashboardName }}"
    (nzOnCancel)="handleViewDetailsModalCancel()"
    (nzOnOk)="handleViewDetailsModalOk()"
>
    <ng-container *nzModalContent>
        <label nz-checkbox [(ngModel)]="modalContextMetadata.overwrite"
            >Overwrite existing context</label
        >
        <nz-select
            [ngModel]="modalContextMetadata.id"
            (ngModelChange)="onModalContextChange($event)"
            nzShowSearch
            nzPlaceHolder="Select existing context"
            [nzDisabled]="!modalContextMetadata.overwrite"
        >
            <nz-option
                *ngFor="let context of savedUserContexts"
                [nzValue]="context.id"
                [nzLabel]="getContextDisplayName(context)"
            ></nz-option>
        </nz-select>
        <input
            nz-input
            placeholder="Context friendly name"
            [(ngModel)]="modalContextMetadata.name"
        />
        <label nz-checkbox [(ngModel)]="modalContextMetadata.isPublic"
            >Set as public</label
        >
        <div *ngIf="modalErrorMessage" class="error-container">
            <p>
                {{ modalErrorMessage }}
            </p>
        </div>
    </ng-container>
</nz-modal>
